module.exports = __webpack_public_path__ + "img/time-to-finish.561ad74c.png";